import React from 'react';

let loginURL = 'https://openhealthboard.auth.us-east-1.amazoncognito.com/login?response_type=code&client_id=kia5571p4f4s9ggc06atju65u&redirect_uri=https://openhealthboard.com/login'
if (process.env.NODE_ENV === 'development') {
	loginURL = 'https://openhealthboard.auth.us-east-1.amazoncognito.com/login?response_type=code&client_id=49ketlr5tqdukv88omai6jphr0&redirect_uri=https://localhost:3001/login'
}

let logoutURL = 'https://openhealthboard.auth.us-east-1.amazoncognito.com/logout?client_id=kia5571p4f4s9ggc06atju65u&logout_uri=https://openhealthboard.com/logout'
if (process.env.NODE_ENV === 'development') {
	logoutURL = 'https://openhealthboard.auth.us-east-1.amazoncognito.com/logout?client_id=49ketlr5tqdukv88omai6jphr0&logout_uri=https://localhost:3001/logout'
}

let client_id = 'kia5571p4f4s9ggc06atju65u';
if (process.env.NODE_ENV === 'development') {
	client_id = '49ketlr5tqdukv88omai6jphr0';
}

let base_url_api = '/api/dev';
if (process.env.NODE_ENV === 'development') {
	base_url_api = 'http://localhost:3000';
}

export const AuthContext = React.createContext({
	loginURL,
	logoutURL,
});

export const RawConfig = {
	loginURL,
	logoutURL,
	client_id,
	base_url_api,
}
